import { call, select } from 'redux-saga/effects';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* updateCustomer(action) {
  const organizationId = yield select((state) => state.organization.uuid);

  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA
  }/${organizationId}/billing/customer`;
  const { success, error } = yield call(callAPI, {
    url,
    method: METHODS.PUT,
    body: action.payload,
  });
  if (!error && success) {
    // TBD update customer success
  }
}
